import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { expandTheme } from 'utils/theme-util';

export const styles = (theme: Theme) => {
  const { palette } = expandTheme(theme);
  const dueSoonTextColor = '#8a6d1d';
  return createStyles({
    listContainer: {
      padding: '20px',
      margin: '0 auto',
      maxWidth: '1360px',
      width: '100%',
      boxSizing: 'border-box',
    },
    column1: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      width: '30%',
    },
    column2: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      width: '20%',
    },
    title: {
      color: '#569177',
      fontSize: theme.spacing(2.5),
      fontWeight: 600,
    },
    questionnaireModal: {
      height: '70%',
      width: '50%',
      background: 'white',
      margin: 'auto',
      marginTop: '8%',
    },
    button: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minWidth: theme.spacing(13),
    },
    selectedButton: {
      backgroundColor: palette.primary.teal,
      color: palette.primary.white,
    },
    reportButton: {
      alignSelf: 'end',
    },
    typeSelectors: {
      'padding': '30px 0',
      '& * + *': {
        marginLeft: '10px',
      },
      '& > *': {
        padding: '16px',
        fontSize: '14px',
        maxWidth: '100%',
        width: 'auto',
      },
    },
    dueSoonBadge: {
      backgroundColor: 'rgba(224, 187, 83, 0.15)',
      color: dueSoonTextColor,
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '15px',
      fontWeight: 500,
      border: '2px solid rgba(224, 187, 83, 0.8)',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      boxShadow: '0 2px 8px rgba(224, 187, 83, 0.25)',
    },
    dueSoonBadgeIcon: {
      fontSize: '17px',
      marginRight: '2px',
      color: dueSoonTextColor,
    },
    overdueBadge: {
      backgroundColor: 'rgba(211, 47, 47, 0.1)',
      color: theme.palette.error.main,
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '15px',
      fontWeight: 500,
      border: '2px solid rgba(211, 47, 47, 0.8)',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      boxShadow: '0 2px 8px rgba(211, 47, 47, 0.2)',
    },
    overdueBadgeIcon: {
      fontSize: '17px',
      color: theme.palette.error.main,
    },
    dueSoonRow: {
      '& td:not(:last-child)': {
        color: `${dueSoonTextColor}!important`,
      },
    },
    overdueRow: {
      '& td:not(:last-child)': {
        color: `${theme.palette.error.main}!important`,
      },
    },
  });
};
